export default {
	section_banner: {
		title: {
			one: 'Business',
			two: 'Payment',
		},
		main_title: {
			one: '& Funding',
			two: 'Access',
		},
		paragraph: {
			one: 'Simplify business transactions with us when you transfer, spend, move & manage funds efficiently.',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Contact Sales Dept',
		},
	},

	question_sec: {
		label: 'Learn about JPWorldPay for business use',
		title: {
			one: 'Do You Need A Highly',
			two: 'Customizable',
			three: 'Commercial',
			four: 'Solution',
			five: 'For Your',
			six: 'Business?',
		},
		cta_buttons: {
			one: 'About Our Business',
		},
	},

	advantage_sec: {
		label: 'Pay For Online',
		title: {
			one: 'Purchase',
			two: 'Conveniently',
		},
		paragraph:
			'Use your JPWorldPay balance to pay for online and direct business fees. Whether you’re making digital purchases, settling service costs, or managing vendor payments, JPWorldPay provides a fast, secure, and convenient way to handle it all.',
	},

	advntage_btm_inn_dwn_1st: {
		label: 'Payment Options',
		title: 'If You Just Pay',
		paragraph: {
			one: 'Save time and trouble sending funds ',
			two: 'electronically',
		},
		cta_buttons: {
			one: 'How To Transfer',
		},
	},

	advntage_btm_inn_dwn_2nd: {
		label: 'Accepted Payments',
		title: 'Make A Payment',
		paragraph: {
			one: 'You can easily send it to multiple people and places ',
			two: 'simultaneously',
		},
		cta_buttons: {
			one: 'About The Sales',
		},
	},

	advntage_btm_inn_dwn_3rd: {
		label: 'Make Payments Quickly',
		title: 'Getting Started Today',
		paragraph: {
			one: 'Join a seller who relies on JPWorldPay.Start accepting ',
			two: 'payments quickly.',
		},
		cta_buttons: {
			one: 'Join With Us',
		},
	},

	charging_sec: {
		label: 'Everything You Need To Know About',
		title: {
			one: 'Usage, Rewards & Account',
			two: 'Requirements',
		},
		paragraph: {
			one: 'To maintain and use money with JPWorldPay, you must have a JPWorldPay business account or a JPWorldPay balance account.',
			two: 'Transactions that allow you to receive bonus cashback when you purchase JPWorldPay Business Debit BlockChain are as follows. Credit transactions signed by you and processed by blockchain cards, cash withdrawals, transactions processed as cash services or using PINS for transactions with no cashback offers.',
			three:
				'"JPWorldPay Business Debit BlockChain" is issued by JPWorldPay. The card can be used wherever JPWorldPay is allowed. This is just the card issuer and is not responsible for any related accounts or other products, services or suggestions.',
		},
		cta_buttons: {
			one: 'Get Started',
		},
	},

	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
